class EditShiftErrorModalController {
  /* @ngInject */
  constructor ($mdDialog, message) {
    this.$mdDialog = $mdDialog;
    this.message = message;
  }

  cancel = () => {
    this.$mdDialog.cancel();
  }
}

export default EditShiftErrorModalController;
